import type { EventMarketPeriodType } from "app/types/eventType";
import flatten from "lodash/flatten";
export class GetListOfMarketIDsHelper {
  static getListOfMarketIDs: (
    marketPeriods: EventMarketPeriodType[]
  ) => EventMarketPeriodType[] = (marketPeriods: EventMarketPeriodType[]) => {
    // Takes a list of marketPeriods
    // Returns a list of market ids for each market in each marketPeriod
    if (marketPeriods && marketPeriods.length > 0) {
      const marketTypes = flatten(marketPeriods.map(mp => mp.marketTypes));
      return (
        flatten(marketTypes.map(mt => mt.markets))
          .map(m => m.id)
          .filter(m => m != null) || []
      );
    } else {
      return [];
    }
  };
}
